import React, { useState } from 'react';
import _ from 'lodash';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import { mobilizeiInvoicesService } from '../../../services/mobilizei/invoices.service';
import useRecaptcha from '../../../hooks/recaptcha.hook';
import { mapIntegerInCentsToCurrency } from '../../../utils/mappers';

/**
 * Offers the Pix Automático on an invoice that was created with another payment method.
 *
 * Iugu can't add the recurrence to an invoice that already exists, so the backend issues a
 * new one carrying it (replacing the subscription when it was never paid) and cancels this
 * one. The customer is then sent to the new invoice, where a single QR Code pays the charge
 * and authorizes the next ones.
 */
export default function AutomaticPixSwitch({ invoice }) {
    const [loading, setLoading] = useState(false);
    const { recaptchaElement, getRecaptchaData } = useRecaptcha();

    const onConfirm = async () => {
        setLoading(true);

        const recaptchaData = await getRecaptchaData();
        if (!recaptchaData) {
            setLoading(false);
            return;
        }

        await mobilizeiInvoicesService.switchToAutomaticPix(invoice.id, recaptchaData)
            .then(response => {
                if (!response?.invoiceId) {
                    throw new Error('missing invoice');
                }

                window.location.assign(`/faturas/${response.invoiceId}`);
            })
            .catch(error => {
                const errorCode = _.get(error, 'error.code', '');
                toast.error(`Não foi possível gerar a cobrança com Pix Automático. Por favor, tente novamente. (#${errorCode})`);
                setLoading(false);
            })
    }

    return (
        <Box>
            <Typography variant="body1" align="center">
                Com o Pix Automático você paga esta cobrança e autoriza as próximas no app do seu banco, em um único QR Code. Nas renovações, o valor é debitado automaticamente e você não precisa fazer nada.
            </Typography>
            <Typography variant="body2" align="center" color="textSecondary" mt={2}>
                Ao continuar, vamos gerar uma nova cobrança de {mapIntegerInCentsToCurrency(invoice.totalInCents)} com o QR Code do Pix Automático. Esta fatura atual será cancelada.
            </Typography>

            <Box alignItems="center" display="flex" justifyContent="center" my={4}>
                {loading ? (
                    <CircularProgress color="primary" />
                ) : (
                    <Button variant="contained" color="primary" disableElevation onClick={onConfirm}>
                        Pagar com Pix Automático
                    </Button>
                )}
            </Box>

            {recaptchaElement}
        </Box>
    );
}
